import Loader from '../../components/Loader';
import LocationDropdown from '../../components/location-dropdown/LocationDropdown';
import LocationIcon from '../../components/icons/LocationIcon';
import { AuthState, AuthStateLoginStatus } from '../../types/auth';
import { ClickAwayListener } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { LocationSelector, LocationStatus } from '../../types/location';
import { locationSelector$ } from '../../utils/location';
import { NavButton, Root } from './NavbarLocationStyle';
import { palette } from '../../theme/palette';
import { RootState, useAppSelector } from '../../redux/store';
import { useEffect, useState } from 'react';
import { useLocationSelector } from '../../hooks/useLocationSelector';

function NavbarLocation() {
  const location = useAppSelector((state: RootState) => state.location.userLocation);
  const locationStatus = useAppSelector((state: RootState) => state.location.status);
  const auth: AuthState = useAppSelector((state: RootState) => state.auth);
  const [popupOpen, setPopupOpen] = useState<boolean>(false);
  const locationSelector = useLocationSelector();

  const handleClose = () => {
    if (locationSelector$.getValue() === LocationSelector.DROPDOWN) {
      locationSelector.close();
    }
  };

  const handleClick = () => {
    if (locationSelector$.getValue() !== LocationSelector.DROPDOWN) {
      locationSelector.open(LocationSelector.DROPDOWN);
    } else {
      locationSelector.close();
    }
  };

  useEffect(() => {
    handleClose();
  }, [location]);

  useEffect(() => {
    const subscription = locationSelector$.subscribe((e) => {
      setPopupOpen(e === LocationSelector.DROPDOWN ? true : false);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Root>
        <NavButton
          disableRipple
          className='location-navlink-button'
          startIcon={<LocationIcon />}
          onClick={handleClick}
        >
          {locationStatus === LocationStatus.IS_LOADING ||
          auth.loginStatus === AuthStateLoginStatus.LOADING ? (
            <Loader hexColourCode={palette.custom.white} />
          ) : (
            (location &&
              (location.city && location.state ? (
                `${location.city}, ${location.state}`
              ) : location.address ? (
                location.address
              ) : (
                <FormattedMessage id={'navbar.setLocation'} />
              ))) || <FormattedMessage id={'navbar.setLocation'} />
          )}
        </NavButton>
        {<LocationDropdown isOpen={popupOpen} />}
      </Root>
    </ClickAwayListener>
  );
}

export default NavbarLocation;
